import React from "react";
import { Show, SimpleShowLayout, TextField, DateField } from "react-admin";
import { dateOptions } from "utils/options";

const ShowTheme = () => {
  return (
    <Show title="Детайли на тема">
      <SimpleShowLayout>
        <TextField
          label="№"
          source="id"
        />
        <TextField
          label="Тема"
          source="name"
        />
        <DateField
          label="Дата на публикуване"
          source="started_on"
          locales={"bg"}
          options={dateOptions}
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowTheme;
